import type { Station } from "./m3u";

export type SearchableStation = Station & { id: number; haystack: string };

export function toSearchable(stations: Station[]): SearchableStation[] {
  return stations.map((station, index) => ({
    ...station,
    id: index,
    haystack: `${station.name} ${station.genres.join(" ")}`.toLowerCase(),
  }));
}

// Every whitespace-separated term must appear in the station's name or genres.
export function searchStations(stations: SearchableStation[], query: string): SearchableStation[] {
  const terms = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (terms.length === 0) return stations;
  return stations.filter((station) => terms.every((term) => station.haystack.includes(term)));
}
